import React from 'react'
import List from './List'
import { useCandidateCreatedUpdatedById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const candidate = useCandidateCreatedUpdatedById(id)
  return (
    <List candidate={candidate} />
  )
}

export default Body
